// frontend/src/components/athleteEditor/editorConfig.js
//
// The addressing seam that lets one editor serve two surfaces.
//
// The athlete-facing pages call self-scoped endpoints (/event-marks/me,
// /athletes/accolades) and send only a bearer token; when a GUARDIAN is acting,
// ActingAthleteContext's global axios interceptor appends as_athlete_id for
// them. The admin edit panel targets the same endpoints but must name the
// athlete explicitly, because it deliberately stays OUT of that context —
// entering it would flip the whole app into the athlete's navigation.
//
// So every shared editor accepts an optional `getConfig`. Absent, it behaves
// exactly as it did before this prop existed; supplied, the caller decides who
// the request is about. That default is what keeps the athlete-facing pages
// unchanged by the admin work.

export const selfConfig = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

// Editors call this once: `const getConfig = resolveGetConfig(getConfigProp)`.
export const resolveGetConfig = (getConfig) => getConfig || selfConfig;
